import { Placement } from '@popperjs/core';
import classNames from 'classnames';
import React, { useRef, useState } from 'react';
import { Content } from 'src/common/interfaces/content.interface';
import { DotMenuStrongIcon } from 'src/monet/icons';
import { LibraryContentCardMenuOptions } from './options';
import { apiGetContentUsage } from 'src/utils/journeyApi';

export const LibraryContentCardMenuActions = ({
  contentId,
  onContentDelete,
  onTagsUpdate,
}: {
  contentId: Content['id'];
  onContentDelete: (id: Content['id']) => void;
  onTagsUpdate: (content: Content) => void;
}) => {
  const usageCountRef = useRef(-1);
  const [keepMenuOpen, setKeepMenuOpen] = useState(false);
  const menuPlacementRef = useRef<Placement>();

  const onMenuOpened = (placement?: Placement) => {
    menuPlacementRef.current = placement;
    if (usageCountRef.current < 0) {
      apiGetContentUsage(contentId).then((response) => {
        usageCountRef.current = response.num_journeys;
      });
    }
    setKeepMenuOpen(true);
  };

  const onMenuClosed = () => {
    setKeepMenuOpen(false);
  };

  return (
    <div
      className={classNames(
        'flex grow-0 items-center space-x-sm transition opacity-0 group-hover:opacity-100',
        keepMenuOpen ? 'opacity-100' : 'opacity-0'
      )}
      onClick={(event) => {
        event.stopPropagation();
      }}
    >
      <LibraryContentCardMenuOptions
        contentId={contentId}
        onContentDelete={onContentDelete}
        onTagsUpdate={onTagsUpdate}
        usingJourneyCount={usageCountRef.current}
        placement={menuPlacementRef.current}
        onMenuOpen={onMenuOpened}
        onMenuClose={onMenuClosed}
        renderMenuOrigin={(onClick) => (
          <div onClick={onClick}>
            <DotMenuStrongIcon />
          </div>
        )}
      />
    </div>
  );
};
